import { Injectable } from '@angular/core';
import { LocalStorage } from 'src/utils/local-storage';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CpsNavigationService {

  constructor(
    private localStorage: LocalStorage,
    private authService: AuthService,
    private translationService: TranslateService
  ) {}

  goToCps(): void {
    const refreshToken = this.localStorage.getRefreshToken();

    this.authService.getpParam(refreshToken).subscribe(p => {
      let url = `${environment.CPS2_DOMAIN}?p=${p.pParam}`;
      url += '&lang=' + this.translationService.currentLang;
      window.location.href = url;
    });
  }
}